import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

// replace console.* for disable log on production
if (process.env.NODE_ENV === 'development') {
  console.log = () => {}
  console.error = () => {}
  console.debug = () => {}
  console.warn = () => {}
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
